import React from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const Wrapper = styled.div`
  text-align: center;
  width: calc(100vw - 40px);
  max-width: 1000px;
  margin-bottom: 30px;
  padding: 0 20px;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    text-align: left;
    margin-bottom: ${props =>
      props.smargin ? '30px' : props.noText ? '25px' : '50px'};
    padding: 0;
  `};
`;

const H2 = styled.h2`
  color: #242424;
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin-bottom: 10px;

  ${breakpoint('tablet')`
    font-size: 28px;
    line-height: 32px;
  `};
`;

const P = styled.p`
  color: #686868;
  font-size: 15px;
  line-height: 17px;
  margin-bottom: 0;
  ${props => (props.half ? 'max-width: 564px;' : '')}
`;

const TextBlock = ({ heading, text, smargin, half }) => {
  return (
    <Wrapper noText={!text} smargin={smargin}>
      <H2>{heading}</H2>
      <P half={half}>{text}</P>
    </Wrapper>
  );
};

export default TextBlock;



// WEBPACK FOOTER //
// ./src/routes/Shop/blocks/text.js